import { Provider1HotelType } from "@/types/provider1";

export function formatFavoredHotels(hotels: { [key: string]: Provider1HotelType[] }) {
  let formattedHotels: { [key: string]: string[] } = {};
  Object.entries(hotels).map(([city, hotelsArray]) => {
    formattedHotels[city] = hotelsArray.map((hotel) =>
      hotel.id
    );
  });

  return formattedHotels
}
